import React from 'react';
import { Avatar, Text } from '@morressier/ts';
import * as Styles from './styles';

const Presenter: React.FC<{ user: SessionPosterUser; eventId?: string }> = props =>
  props.user ? (
    <>
      <Styles.VideoAuthor>
        <Avatar
          customSize="3rem"
          customFontSize="1.5rem"
          fullName={props.user.full_name}
          src={props.user.picture_url}
          style={{ margin: '0 0.5rem 0 0' }}
        />
        <div>
          <Text as="a" target="blank" fontWeight="bold" style={{ marginBottom: '0.2rem' }}>
            {props.user.full_name}{' '}
          </Text>
          <Styles.VideoAuthorFrom>
            {/* these spans are necessary for styling */}
            <span>{props.user.department}</span>
            <span>{props.user.organization}</span>
          </Styles.VideoAuthorFrom>
        </div>
      </Styles.VideoAuthor>
    </>
  ) : null;

export default Presenter;
